import {lazy} from "react"

export const CodePromo = lazy(() => import("@/views/codePromo/CodePromo"))
export const CodePromoModal = lazy(() => import("@/views/codePromo/components/CodePromoModal"))